import { createStore, get, set, del, keys } from "idb-keyval";

export type Voice = "arcas" | "apollo" | "orpheus" | "orion" | "luna" | "aurora";
export type Speed = 0.75 | 1 | 1.25 | 1.5 | 1.75 | 2 | 2.5;

export interface DocumentRecord {
  id: string;
  title: string;
  text: string;
  sourceType: "paste" | "clipboard" | "pdf" | "docx" | "image" | "txt";
  chunkIndex: number;
  positionSec: number;
  voice: Voice;
  speed: Speed;
  createdAt: number;
  lastOpened: number;
}

const store = createStore("josh-mainframe", "documents");

export async function saveDocument(doc: DocumentRecord): Promise<void> {
  await set(doc.id, doc, store);
}

export async function loadDocument(id: string): Promise<DocumentRecord | undefined> {
  return get<DocumentRecord>(id, store);
}

export async function deleteDocument(id: string): Promise<void> {
  await del(id, store);
}

export async function listDocuments(): Promise<DocumentRecord[]> {
  const allKeys = await keys(store);
  const docs = await Promise.all(
    allKeys.map((key) => get<DocumentRecord>(key as string, store))
  );
  return docs
    .filter((d): d is DocumentRecord => Boolean(d))
    .sort((a, b) => b.lastOpened - a.lastOpened);
}

export function makeDocumentId(): string {
  return `doc_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

export function deriveTitle(text: string): string {
  const firstLine = text.split("\n").map((l) => l.trim()).find(Boolean) ?? "Untitled";
  return firstLine.length > 60 ? `${firstLine.slice(0, 57)}...` : firstLine;
}
